
import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Layout, Form, Modal as antmodal } from 'antd';
import { theme, Text, Tabs, Modal } from '@pfmam/pfmam';
import { Container, Box, Banner } from '../styles/globalStyle';
import AppLayout from '../common/layouts/appLayout';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Prompt } from 'react-router';
import CreateWireInstructionsComponent from './components/createWireInstructionsComponent';
import CreateWireInstructionsAccountPermissionsComponent from './components/createWireInstructionsAccountPermissionsComponent';
import {
  pickBeneficiaryAddressFields,
  omitBeneficiaryAddressFields,
} from './components/beneficiaryAddressFields';
import { GetWireAccountsPermissionsGridData, GetWirePayeeInstructionsDetails, CreateWirePayeeInstruction, GetStatesWithDescription } from '../actions/actions';
const { Content } = Layout;

export const OverrideStyles = createGlobalStyle`
  .helpful-dropdown-menu {
    .ant-dropdown-menu {
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
        0px 6px 16px rgba(0, 0, 0, 0.08);
      border-radius: 2px;
      padding: 4px 0;
      .ant-dropdown-menu-item {
        font-size: ${theme.font_size.size_l};
        line-height: 20px;
        color: ${theme.colors.black_secondary};
        padding: 8px 12px;
        &:hover {
          background: ${theme.colors.light_grey};
        }
        .anticon {
          margin-right: 8px;
        }
      }
      .
    }
  }
  .rc-virtual-list-scrollbar-thumb {
    background: rgb(0, 0, 0, 0.2) !important;
  }
  .profile-card {
    border-color: ${theme.colors.transparent} !important;
    .ant-card-head {
      padding: 0 32px;
      border-color: ${theme.colors.grey_fossil};
    }
    .ant-card-head-title {
      font-size: ${theme.font_size.size_3xl};
      line-height: 32px;
      padding: 24px 0;
    }
    .ant-card-body {
      padding: 32px;
    }
  }
  .statement-dropdown {
    width: 210px !important;
    .ant-dropdown-menu {
      padding: 0;
      box-shadow: ${theme.shadows.dropdown};
    }
    .ant-select-item {
      font-weight: normal;
      font-size: ${theme.font_size.size_l};
      color: ${theme.colors.black_secondary};
      line-height: 20px;
      padding: 8px 12px;
      &:hover {
        background: ${theme.colors.light_grey} !important;
      }
      &.ant-select-item-option-active,
      &.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
        :not(.ant-select-item-option-disabled) {
          background: ${theme.colors.transparent};
        }
      }
    }
  }
`;

const ContentWrapper = styled(Content)`
  .ant-table {
    border-radius: 4px;
    .ant-table-tbody {
      & > tr {
        cursor: pointer;
        &:hover {
          &.ant-table-row:not(.ant-table-expanded-row) {
            background: linear-gradient(
                0deg,
                rgba(23, 54, 93, 0.07),
                rgba(23, 54, 93, 0.07)
              ),
              ${theme.colors.white};
          }
        }
        & > td {
          vertical-align: top;
          padding: 20px 32px;
          &.ant-table-column-sort {
            background: ${theme.colors.transparent};
          }
        }
        &:last-child {
          & > td {
            border-bottom-color: ${theme.colors.transparent};
          }
        }
      }
    }
    .ant-table-thead {
      & > tr {
        & > th {
          background: ${theme.colors.light_grey};
          font-family: 'Inter';
          padding: 0 32px;
          font-weight: normal;
          line-height: 20px;
          &:not(:last-child) {
            &:not(.ant-table-selection-column) {
              &:not(.ant-table-row-expand-icon-cell) {
                &:not([colspan]) {
                  &::before {
                    background-color: ${theme.colors.transparent};
                  }
                }
              }
            }
          }
        }
      }
    }
    &.ant-table.ant-table-middle {
      .ant-table-thead {
        .ant-table-column-sorters {
          padding: 0;
          .ant-table-column-sorter-inner .anticon {
            color: ${theme.colors.grey_stone};
          }
          .ant-table-column-sorter-up.active,
          .ant-table-column-sorter-down.active {
            color: ${theme.colors.black_sorted};
          }
        }
        .ant-table-column-sorter-inner {
          margin-top: 0;
        }
      }
    }
    .sort-space-none {
      .ant-table-column-sorters {
        justify-content: flex-start;
      }
      .ant-table-column-title {
        flex: 0 0 auto;
      }
      &.flex-end {
        .ant-table-column-sorters {
          justify-content: flex-end;
        }
      }
    }
    .ant-avatar {
      min-width: 40px;
    }
  }
  .ant-table-title {
    padding: 0 !important;
  }
  .ant-table {
    &.ant-table-middle {
      .ant-table-tbody {
        .ant-table-wrapper {
          &:only-child {
            .ant-table {
              margin: -19px -32px;
            }
          }
        }
        .ant-table-container {
          .ant-table-tbody {
            .ant-table-row {
              .ant-table-cell {
                padding: 20px 32px;
                background-color: ${theme.colors.grey_faint};
              }
              &:hover {
                .ant-table-cell {
                  background-color: transparent;
                }
              }
            }
          }
        }
      }
    }
  }
`;

const CreateWireInstructionsContainer = (props) => {
  if (!props?.location?.state?.canNavigateInstruction) {
    history.push("/404");
  }
  const history = useHistory();
  const [form] = Form.useForm();
  const connectLoggedInContactId = useSelector((state) => state.userSlice.user.profile.sub);
  const clientDetails = useSelector((state) => state.programsClientsSlice.selectedClient);
  const ssnorTIN = clientDetails.payload[0].ssnortin;
  const programId = clientDetails.payload[0].programid;
  const primary_color = useSelector((state) => state.siteInfo.primaryColor);
  const [isTouched, setIsTouched] = useState(false);

  const bankName = props.location.state.bankName;
  const bankCity = props.location.state.bankCity;
  const bankState = props.location.state.bankState;
  const abaNumber = props.location.state.abaNumber;

  const [accountPermisionsInitialState, setAccountPermissionsInitialState] = useState(null);
  const [accountPermisionsDataSource, setAccountPermissionsDataSource] = useState(null);
  const [permissionsModalVisible, setPermissionsModalVisible] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);
  const [canSubmitInstruction, setCanSubmitInstruction] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitConfirmation, setIsSubmitConfirmation] = useState(false);
  const [states, setStates] = useState([]);
  const [promptEnabled, setPromptEnabled] = useState(true);


  useEffect(() => {

    GetStatesWithDescription().then((response) => {
      const stateList = [];
      if (response.data != null && response.data.length > 0) {
        response.data.map((val) => {
          const option = {};
          option.label = val.Code;
          option.value = val.Code;
          stateList.push(option);
        });
        setStates(stateList);
      }
    }).catch((err) => {
      handleError(err);
    });

    GetWireAccountsPermissionsGridData(null, connectLoggedInContactId, ssnorTIN, programId).then((response) => {
      if (response.data.Table.length > 0) {
        setAccountPermissionsInitialState(response.data.Table);
        setAccountPermissionsDataSource(response.data.Table);
      }
    }).catch((err) => {
      handleError(err);
    });
  }, []);

  const beneLengthExceedOk = () => {
    setPromptEnabled(true);
    setSubmitted(false);
  };

  const noAccountLinkedOk = () => {
    setPromptEnabled(true);
    setSubmitted(false);
  };

  const onSubmit = () => {
    setPromptEnabled(false);
    setSubmitted(true);
 
    const formValues = form.getFieldsValue();
    const wireDetails = omitBeneficiaryAddressFields(formValues);
    const beneficiaryAddress = pickBeneficiaryAddressFields(formValues);

    if (!canSubmitInstruction) {
      antmodal.warning({
        title: 'At least one account should be associated with the Wire Instruction!',
        okText: 'Ok',
        onOk: noAccountLinkedOk
      });
    } else {
      if ((wireDetails.BeneName != null ? wireDetails.BeneName.length : 0) + (wireDetails.BeneAccountNumber != null ? wireDetails.BeneAccountNumber.length : 0) + (wireDetails.BeneDetails != null ? wireDetails.BeneDetails.length : 0) > 140) {
        antmodal.warning({
          title: 'Wire File cannot support Beneficiary Information of more than 140 Characters!',
          okText: 'Ok',
          onOk: beneLengthExceedOk
        });
      } else {
        var hasAccountPermissionChanged = true;
        CreateWirePayeeInstruction(wireDetails, accountPermisionsDataSource, ssnorTIN, hasAccountPermissionChanged, beneficiaryAddress).then((response) => {
          if (response.data) {
            setIsSubmitConfirmation(true);
          }
          setSubmitted(false);
        }).catch((err) => {
          setSubmitted(false);
          handleError(err);
        });
      }
    }
  };

  const handleError = (err) => {
    console.log(err);
    antmodal.warning({
      title: 'There was an error processing the request. Please try again.',
      okText: 'Ok',
      onOk: () => {
        history.push("/dashboard");
      },
    });
  };

  const OnAccountsPermissionsOkClick = () => {
    var canSubmitInstruction = false;
    accountPermisionsDataSource.map(items => {
      if (items.HasAccess === 1) {
        canSubmitInstruction = true;
      }
    });

    setCanSubmitInstruction(canSubmitInstruction);
    setPermissionsModalVisible(false);
  };

  const OnAccountsPermissionsCancelClick = () => {
    setCanSubmitInstruction(false);
    setAccountPermissionsDataSource(accountPermisionsInitialState);
    setPermissionsModalVisible(false);
  };

  const handleConfirmationModalCancel = () => {
    setIsSubmitConfirmation(false);
    //navigate to Team Members screen.
    history.push("/settings", { showWirePayeeInformation: true });
  };


  return (
    <AppLayout>
      <Prompt
        when={isTouched && promptEnabled}
        message={JSON.stringify({
          header: 'Discard Changes?',
          content:
            'Changes have not been submitted, leaving this page will result in no change of wire instruction or account permissions. Are you sure you want to leave this page?',
        })}
      />
      <OverrideStyles />
      <ContentWrapper>
        <Banner bgcolor={primary_color} height="124px">
          <Box
            display="flex"
            alignitems="center"
            height="100%"
            minwidth="100%"
            width="100%"
            zindex="3"
            position="relative"
            padding="44px 0 36px 0"
          >
            <Container>
              <Box
                display="flex"
                justifycontent="space-between"
                alignitems="flex-start"
                margin="0"
              >
                <Box flex="1">
                  <Text
                    color={`${theme.colors.white}`}
                    fontSize="36px"
                    lineheight="44px"
                    label="New Wire Account"
                  />
                </Box>
              </Box>
            </Container>
          </Box>
        </Banner>

        <>
          <CreateWireInstructionsComponent
            form={form}
            onSubmit={onSubmit}
            bankName={bankName}
            bankCity={bankCity}
            bankState={bankState}
            abaNumber={abaNumber}
            setPermissionsModalVisible={setPermissionsModalVisible}
            canSubmitInstruction={canSubmitInstruction}
            setIsTouched={setIsTouched}
            submitted={submitted}
            states={states}
          />

          <Modal
            // title="Permissions"
            //width="auto"
            style={{ minWidth: 800 }}
            onOk={() => setPermissionsModalVisible(!permissionsModalVisible)}
            bodyStyle={{
            }}
            maskStyle={{
              backgroundColor: `${theme.rgba.modal}`,
            }}
            content={
              <CreateWireInstructionsAccountPermissionsComponent
                accountPermisionsDataSource={accountPermisionsDataSource}
                setAccountPermissionsDataSource={setAccountPermissionsDataSource}
                OnAccountsPermissionsOkClick={OnAccountsPermissionsOkClick}
                OnAccountsPermissionsCancelClick={OnAccountsPermissionsCancelClick}
                formDisabled={formDisabled}
                setIsTouched={setIsTouched}
              />
            }
            visible={permissionsModalVisible}
            closable={false}
            footer={null}
            centered={true}
          />
        </>
      </ContentWrapper>


      {isSubmitConfirmation && (
        <Modal
          title=
          {
            <p>
              <div>
                <span>New Linked Wire Account Saved</span>
                <br />
                <p style={{ fontStyle: "italic", fontSize: "16px", lineHeight: "20px", whiteSpace: "normal" }}>Pending Approval</p>
              </div>
            </p>
          }
          width={590}
          bodyStyle={{
            padding: '10px 32px 34px 32px',
          }}
          maskStyle={{
            backgroundColor: `${theme.rgba.modal}`,
            zIndex: '1051',
          }}
          content={'Allow up to 48 hours for PFM Asset Management approval, at which time account will be available for use.'}
          visible={isSubmitConfirmation}
          onCancel={handleConfirmationModalCancel}
          okText={'Ok'}
          footer={null}
          centered={true}
          closable={true}
          cancelButtonProps={{ style: { display: 'none' } }}
          maskClosable={false}
        />

      )}
    </AppLayout>
  );
};

export default CreateWireInstructionsContainer;